const styles = () => ({
    containerAddessTitle: {
        alignItems: 'center',
        marginTop: '20px',
    },
    addressTitle: {
        fontWeight: '500',
        margin: '0',
    },
    positionRelative: {
        position: 'relative',
    },
    circularProgress: {
        position: 'absolute',
        top: '35px',
        right: '20px',
    },
});

export default styles;
